var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f;opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tiles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,8H12a4,4,0,0,0-4,4V40a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V12A4,4,0,0,0,40,8ZM36,36H16V16H36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,52H12a4,4,0,0,0-4,4V84a4,4,0,0,0,4,4H40a4,4,0,0,0,4-4V56A4,4,0,0,0,40,52ZM36,80H16V60H36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84,8H56a4,4,0,0,0-4,4V40a4,4,0,0,0,4,4H84a4,4,0,0,0,4-4V12A4,4,0,0,0,84,8ZM80,36H60V16H80Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84,52H56a4,4,0,0,0-4,4V84a4,4,0,0,0,4,4H84a4,4,0,0,0,4-4V56A4,4,0,0,0,84,52ZM80,80H60V60H80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiles);
export default __webpack_public_path__ + "static/media/tiles.90316e3d9e9b3d2c850f751cf7c3aa55.svg";
export { ForwardRef as ReactComponent };